import React, { useContext, useEffect, useState } from 'react'
import { Dropdowns, Pagination, SearchAndAddBtn, Switch, THead } from '../../../Components';
import { Card, CardBody, IconButton, Checkbox, Spinner, Tooltip } from "@material-tailwind/react";
import Zoom from "react-medium-image-zoom";
import { BiEdit } from 'react-icons/bi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { RxHamburgerMenu } from 'react-icons/rx';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { NewContext } from '../../../Context/NewContext';
import { get_font_data, update_font_priority } from '../../../Controller/actions';
import { ThemeFontModel } from './../../../Components/Modals/ThemeFontModel';



const Font = ({ title }) => {

    const { permissions, currentPageChildData, isChildLoading, tokenType, deleteUpdateItem, deleteUpdateYes, setopenSubCategory, setHomeTableData, setDeleteUpdateTag, setDeleteUpdateItem, setAddEditDeleteTag, setFormData, confirmationModalShow, setConfirmationModalShow, handleSwitchUpdate, isLoading, deleteUpdateTag, checkedValues, handleCheckboxChange, currentPage, totalPage, perPage, search, setDeleteUpdateYes, setIsLoading, setCurrentPage, setPerPage, setTotalPage, currentPageData, setCurrentPageData, filterDropdown, handleOpen, isAscending, sortData, setCurrentHomeModalKey } = useContext(NewContext);

    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });
    const simpleFields = [
        { name: "Preview", },
        { name: "Name", sortable: true, field: 'name' },
        { name: "isPremium", sortable: true, field: 'isPremium' },
        { name: "isTop", sortable: true, field: 'isTop' },
        { name: "isActive", sortable: true, field: 'isActive' },
        { name: "isHot", sortable: true, field: 'isHot' },
        { name: "isLatest", sortable: true, field: 'isLatest' },

    ];
    // const dropdownFields = [{ name: "isActive", }];
    // const totalFields = simpleFields.length + dropdownFields.length + 2;
    const totalFields = simpleFields.length + 2

    const getFontData = async (_currentPage = 1, sortName = sortData, sortType = isAscending) => {
        setIsLoading(true)
        try {
            const getAsset = await get_font_data(_currentPage, perPage, search, filterDropdown, sortName, sortType);
            if (getAsset) {
                const { status, data, currentPage, perPage, totalPage } = getAsset;
                if (status) {
                    setCurrentPageData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage || 1);
                }
                else {
                    setCurrentPageData([]);
                }
                setIsLoading(false);
            }
        } catch (error) {
            console.error('Error fetching wallpaper data:', error);
        }
    };


    useEffect(() => {
        getFontData(currentPage, sortData, isAscending);
        setDeleteUpdateTag("");
    }, [deleteUpdateTag, search, currentPage, perPage, filterDropdown, deleteUpdateYes, pagePermissions, sortData, isAscending]);

    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'Wallpaper')
            setPagePermissions({
                ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D
            })
        }
    }, [tokenType, permissions])

    useEffect(() => {
    }, [pagePermissions])


    useEffect(() => {
        document.title = title;
    }, [title]);

    //drag-drop functionality
    const handleDragEnd = async (e) => {
        if (!pagePermissions?.CU) return;
        if (!e.destination) return;
        let tempData = Array.from(currentPageData);
        let [source_data] = tempData.splice(e.source.index, 1);
        source_data.priority = e.destination.index + 1;
        tempData.splice(e.destination.index, 0, source_data);
        let newData = tempData.map((_ele, i) => ({ ..._ele, priority: i + 1 }));
        const { data, status } = await update_font_priority({ updates: newData })
        if (status) {
            getFontData(currentPage, sortData, isAscending);
        }
    };

    return (
        <>
            <SearchAndAddBtn title={`Font`} resetFilterBtn={true} addBtn={pagePermissions?.CU} deleteUpdateTag="all-delete-font"
            />
            <Card className="overflow-hidden w-full rounded-md shadow-none">
                <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">
                    <DragDropContext onDragEnd={handleDragEnd}>
                        <table className="w-full min-w-max table-auto text-left ">
                            <THead simpleFields={simpleFields} />
                            <Droppable droppableId="theme-wallpaper-list">
                                {(provided) => (
                                    <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                        {
                                            isLoading ?
                                                <tr>
                                                    <td colSpan={totalFields} className='py-12'>
                                                        <div className="flex justify-center items-center">
                                                            <Spinner />
                                                        </div>
                                                    </td>
                                                </tr>
                                                : currentPageData?.length === 0 ?
                                                    <tr>
                                                        <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                            <div className="flex justify-center items-center">
                                                                No Data Found
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    : currentPageData?.map((_ele, i) => {
                                                        const isLast = i === currentPageData?.length - 1;
                                                        const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;
                                                        return (
                                                            <Draggable key={_ele._id} draggableId={_ele._id} index={i}>
                                                                {(provided, snapshot) => (
                                                                    <tr className='border-b border-blue-gray-50' ref={provided.innerRef}  {...provided.draggableProps}  {...provided.dragHandleProps} >
                                                                        <td className={classes}>
                                                                            <Checkbox
                                                                                className='w-[18px] h-[18px] border-[1.5px] rounded-[3.6px] border-[#1E3354] checked:bg-[#0047FF] checked:border-transparent'
                                                                                id={`slider-${_ele._id}`}
                                                                                value={`${_ele._id}`}
                                                                                disabled={!pagePermissions?.CU}
                                                                                checked={checkedValues.includes(`${_ele._id}`)}
                                                                                onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                                            />
                                                                        </td>
                                                                        <td className={`${classes}`}>
                                                                            <div className='imgTd relative'>
                                                                                <img src={_ele.fontSmallPreview || `../../../assets/images/no-image.png`} alt={_ele.name} className='mr-0 h-[55px] rounded-lg block absolute !w-20 truncate' />
                                                                                <Zoom>
                                                                                    <img src={_ele.fontSmallPreview || `../../../assets/images/no-image.png`} alt={_ele.name} className='mr-0 h-[55px] rounded-lg block !w-20 truncate' />
                                                                                </Zoom>
                                                                            </div>
                                                                        </td>
                                                                        <td className={classes}>
                                                                            <div className="flex items-center">
                                                                                <span className={`font-normal text-[17px] !w-25  ${!_ele.name && `text-gray-500`}`}>{_ele.name || `None`}</span>
                                                                            </div>
                                                                        </td>
                                                                        {
                                                                            ["isPremium", "isTop", "isActive", "isHot", "isLatest"].map((_is_ele, i) => (
                                                                                <td className={classes} key={i}>
                                                                                    <div className="ml-1">
                                                                                        <Switch disabled={!pagePermissions?.CU} id={_ele._id} name={_is_ele} onChange={(e) => { setDeleteUpdateYes("update-theme-font"); handleSwitchUpdate(e); }} checked={_ele[_is_ele]} />
                                                                                    </div>
                                                                                </td>
                                                                            ))
                                                                        }
                                                                        <td className={classes}>
                                                                            <div className="flex items-center gap-2">
                                                                                <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.CU} onClick={() => { setDeleteUpdateYes("update-theme-font"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }}>
                                                                                    <BiEdit />
                                                                                </IconButton>
                                                                                <IconButton className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.D} onClick={() => { setDeleteUpdateYes("delete-theme-font"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                                                    <RiDeleteBinLine />
                                                                                </IconButton>
                                                                            </div>
                                                                        </td>
                                                                        <td className={classes} {...provided.dragHandleProps}>
                                                                            <RxHamburgerMenu size={24} />
                                                                        </td>
                                                                    </tr>
                                                                )
                                                                }
                                                            </Draggable>
                                                        );
                                                    })
                                        }
                                        {provided.placeholder}
                                    </tbody>
                                )}
                            </Droppable>
                        </table>
                    </DragDropContext>
                </CardBody>
            </Card >
            {
                totalPage > 1 &&
                <Pagination currentPage={currentPage} totalPage={totalPage} getData={getFontData} />
            }
            <ThemeFontModel />
        </>
    )
}
Font.defaultProps = {
    title: "Message | Font"
};

export default Font